import {
  SUBSCRIPTIONS_LIST_SUCCESS,
  SUBSCRIPTIONS_INFO_SUCCESS,
  SUBSCRIPTIONS_UPDATE_SUCCESS,
  SUBSCRIPTIONS_STATUS_SUCCESS,
  CLEAR_SUBSCRIPTIONS_INFO,
} from "../actionTypes/subscriptions";

const INIT_STATE = {
  subscriptionList: [],
  subscriptionInfo: {},
  queryInfo: { page: 1, size: 10 },
  totalRecords: 0,
  pages: 0,
};

function subscriptionsReducer(state = INIT_STATE, action) {
  const { type, payload } = action;

  switch (type) {
    case CLEAR_SUBSCRIPTIONS_INFO:
      return {
        ...state,
        subscriptionInfo: {},
      };
    case SUBSCRIPTIONS_LIST_SUCCESS:
      return {
        ...state,
        subscriptionList: payload.data || [],
        totalRecords: payload.count || 0,
        pages: payload.pages || 0,
        queryInfo: payload.queryInfo || state.queryInfo,
      };
    case SUBSCRIPTIONS_INFO_SUCCESS:
      return {
        ...state,
        subscriptionInfo: payload || {},
      };
    case SUBSCRIPTIONS_UPDATE_SUCCESS:
    case SUBSCRIPTIONS_STATUS_SUCCESS:
      return {
        ...state,
        subscriptionInfo: payload || state.subscriptionInfo,
        subscriptionList: state.subscriptionList.map((item) =>
          item._id === (payload && payload._id) ? payload : item
        ),
      };
    default:
      return state;
  }
}

export default subscriptionsReducer;
